import { useRef, useState } from 'react';

import { cdnHost, staticCdnHost } from '@rockalingua/ui/constants/Cdn';

import {
  ControlButton,
  ControlIcon,
  Controls,
  Container,
  VideoElement,
} from './PromoVideo.styled';

const promoVideoAssets = {
  videoPath: `${cdnHost}/videoTutorials/MAINpanel_VID_2024.mp4`,
  posterPath: `${cdnHost}/videoTutorials/promo-video-2023-poster.jpg`,
} as const;

const promoVideoControlIcons = {
  pausePath: `${staticCdnHost}/img/home/player/01_PAUSE.svg`,
  playPath: `${staticCdnHost}/img/home/player/02_PLAY.svg`,
  mutedPath: `${staticCdnHost}/img/home/player/08_sonidoOFF_1.svg`,
  unmutedPath: `${staticCdnHost}/img/home/player/07_sonidoON_1.svg`,
} as const;

export default function PromoVideo() {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);

  const handlePlayPauseClick = async () => {
    const videoElement = videoRef.current;

    if (!videoElement) {
      return;
    }

    if (videoElement.paused) {
      try {
        await videoElement.play();
      } catch {
        setIsPlaying(false);
      }

      return;
    }

    videoElement.pause();
  };

  const handleMuteUnmuteClick = () => {
    const videoElement = videoRef.current;

    if (!videoElement) {
      return;
    }

    videoElement.muted = !videoElement.muted;
    setIsMuted(videoElement.muted);
  };

  const playPauseIconPath = isPlaying
    ? promoVideoControlIcons.pausePath
    : promoVideoControlIcons.playPath;

  const muteUnmuteIconPath = isMuted
    ? promoVideoControlIcons.mutedPath
    : promoVideoControlIcons.unmutedPath;

  return (
    <Container>
      <VideoElement
        ref={videoRef}
        autoPlay
        muted={isMuted}
        loop
        playsInline
        poster={promoVideoAssets.posterPath}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
      >
        <source src={promoVideoAssets.videoPath} type="video/mp4" />
      </VideoElement>
      <Controls>
        <ControlButton
          onClick={handlePlayPauseClick}
          $position="left"
          aria-label={isPlaying ? 'Pause' : 'Play'}
        >
          <ControlIcon src={playPauseIconPath} />
        </ControlButton>
        <ControlButton
          onClick={handleMuteUnmuteClick}
          $position="right"
          aria-label={isMuted ? 'Unmute' : 'Mute'}
        >
          <ControlIcon src={muteUnmuteIconPath} />
        </ControlButton>
      </Controls>
    </Container>
  );
}
